import { useMemo } from 'preact/hooks';
import { useConfigStore } from '../stores/ConfigStore';

export default function usePages(pageNumber) {
	const { layout, blocks, properties } = useConfigStore();
	const addRecaptcha = properties.advanced?.recaptcha?.siteKey;

	return useMemo(() => {
		const pages = [[]];

		layout.forEach(blockId => {
			const block = blocks[blockId];
			if (block.typeName === 'page_break') {
				pages[pages.length] = [];
			} else {
				pages[pages.length - 1].push(blockId);
			}
		});

		if (addRecaptcha) {
			pages[pages.length - 1].push('recaptcha');
		}

		return pageNumber ? pages[pageNumber - 1] : pages;
	}, [layout, blocks, pageNumber, addRecaptcha]);
}
